import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController} from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the OttimizzaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ottimizza',
  templateUrl: 'ottimizza.html',
})
export class OttimizzaPage {
  esito;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private alertCtrl: AlertController,

  ) {
  }

  alert() {
    let alert = this.alertCtrl.create({
      title: "Cancellazione",
      message: "Confermi la cancellazione?",
      buttons: [
        {
          text: 'Confermo',
          handler: () => this.ottimizza()
        },
        {
          text: 'Annulla',
          role: 'cancel',

        }
      ]
    });
    alert.present();

  }

  ottimizza() {
    this.rest.ottimizzazione().subscribe(
      esito => {
      this.esito = esito;
      this.errorMessage="Cancellazione avvenuta con successo";
       
      },
      error => this.errorMessage = <any>error);

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad OttimizzaPage');
    this.errorMessage="";
  }

}



// WEBPACK FOOTER //
// ./src/pages/ottimizza/ottimizza.ts